import {
  PopStoreExtendedSubscriptionLevel,
  PopStoreSubscriptionLevel,
} from '@ps/models/lib/creator-subscription';

/**
 * The paid tiers carry identical string values across both enums; this map makes
 * the widening explicit and type-safe instead of a cast.
 */
const PAID_TO_EXTENDED: Record<
  PopStoreSubscriptionLevel,
  PopStoreExtendedSubscriptionLevel
> = {
  [PopStoreSubscriptionLevel.SUBSCRIBER]:
    PopStoreExtendedSubscriptionLevel.SUBSCRIBER,
  [PopStoreSubscriptionLevel.FAN]: PopStoreExtendedSubscriptionLevel.FAN,
  [PopStoreSubscriptionLevel.VIP]: PopStoreExtendedSubscriptionLevel.VIP,
};

/**
 * Collapse a viewer's paid subscription standing and follow status into the one
 * `PopStoreExtendedSubscriptionLevel` that describes their relationship to a
 * creator: a paid tier wins, a bare follower maps to `FOLLOWER`, and a stranger
 * is `undefined`. Mirrors PopshopRN `makeSynthesizedExtendedSubscriptionLevel`.
 *
 * Pass the *access* level (a canceled-but-still-valid subscription counts) — the
 * extended level gates content access, not billing.
 */
export function synthesizeExtendedSubscriptionLevel(
  accessLevel: PopStoreSubscriptionLevel | undefined,
  isFollowing: boolean,
): PopStoreExtendedSubscriptionLevel | undefined {
  if (accessLevel != null) {
    return PAID_TO_EXTENDED[accessLevel];
  }
  if (isFollowing) {
    return PopStoreExtendedSubscriptionLevel.FOLLOWER;
  }
  return undefined;
}
